<template>
    <div>

        <div>
           <UnavailableMenu />
        </div>
        <!--
        <div class="modal-header tag-partner">
            <img src="/static/quomi-logo.jpg" alt="logo" />
            <h3 class="text-center mt-3 text-bold" v-if="this.$route.name === 'recipe'">Vuoi provare a cucinare con le box ricette Quomi?</h3>
            <h2 class="text-center mt-3 mb-5" v-else>Benvenuto su Quomi!</h2>
        </div>

        <p class="text-justify text-body-small " v-if="this.$route.name === 'recipe'">
            <b>Registrati ora</b> e approfitta della promo di benvenuto. Per te <b>50€ sui primi 5 ordini</b>. In più <b>la spedizione è gratuita</b> sul primo ordine!<br>
            Prova ora una nuova esperienza in cucina con Quomi.
        </p>

        <div class="flex flex-column align-items-center mb-3">
            <v-btn
                outlined
                color="#4285f4"
                class="google-btn tag-partner"
                @click.stop="login('google')"
            >   
                <i class="fab fa-google fa-1.5x"></i>
                <strong class="ml-1 google-text">
                    Registrati con 
                    <span><span class="uppercase">G</span>oogle</span>
                </strong>
            </v-btn>

            <CTA
                :content="$t('auth.signin.f-icon') + ' Registrati con Facebook'"
                :size="`small`"
                :color="`blue`"
                @click="login('facebook')"
								style="border-radius: 30px"
                class="facebook-btn mt-5 tag-partner"
            />

						<v-hover v-slot="{ hover }">
            <v-btn
							class="my-5 email-btn"
              outlined
							:ripple="false"
							@click="openMailRegistration"
							:style="{ 'background-color': hover ? '#8fb732' : null }"
            >
							<strong class="ml-1 email-text">
								<v-icon left>
        					mdi-email-open
      					</v-icon>
								<span><span class="uppercase">R</span>egistrati con la tua email</span>
							</strong>
            </v-btn>
						</v-hover>
        </div>

				<form class="form" method="POST" @submit.prevent="register()" v-show="mailRegistration">
						<div>
								<input
										type="text"
										class="form-control"
										v-model="form.firstname"
										:placeholder="$t('auth.signup.firstname')"
										required
										@input="persistName"
								/>
								<span class="form-highlight"></span>
						</div>

						<div>
								<input
										type="text"
										class="form-control"
										v-model="form.lastname"
										:placeholder="$t('auth.signup.lastname')"
										required
										@input="persistLastName"
								/>
								<span class="form-highlight"></span>
						</div>

						<div>
								<input
										type="text"
										class="form-control"
										:value="form.email"
										@input="inputEmail($event)"
										:placeholder="$t('auth.signup.email')"
										required
										pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$"
								/>
								<span class="form-highlight"></span>
						</div>

						<div>
								<input-password v-model="form.password" />
								<span class="form-highlight"></span>
						</div>

						<flash :flash="errorStore.message" state="error"></flash>

						<CTA
								:content="`Registrati`"
								:disabled="!conditionsAccepted"
								isWithLoader
								:loading="loading"
								class="py-3 signup-cta"
						/>
				</form>
										
				<label class="checkbox">
						<input
								class="checkbox"
								type="checkbox"
								v-model="conditionsAccepted"
						/>

						Iscrivendoti e creando un account, dichiari di essere
						maggiorenne ed aver preso visione e accettato integralmente i
						<router-link
								:to="{ name: 'legal' }"
								target="_blank"
								class="link-detail"
								:title="$t('auth.checkbox.general_conditions')"
								v-html="`Termini e le Condizioni`"
						/>
						e la
						<router-link
								:to="{ name: 'privacy-policy' }"
								class="link-detail"
								:title="$t('auth.checkbox.privacy')"
								target="_blank"
								v-html="`Privacy policy` + ` `"
						/>
						<span class="tag-partner"
								>di Quomi e sarai iscritto alla newsletter di Quomi</span
						>.
				</label>

        <div class="flex justify-content-center mt-5">
            <small>Hai già un account?</small>
            <small>
                <a class="sign-in-link pl-2 text-bold" @click="openSignIn"
                    >Accedi</a
                >
            </small>
        </div>
      -->
    </div>
</template>

<script>
import { container } from "../services/container";

import { errorStore } from "../store/errorStore";
import { UserProvider } from "../providers/UserProvider";
import InputPassword from "./Parts/InputPassword";
import UnavailableMenu from '@/components/Checkout/UnavailableMenu'
import Flash from "./Parts/Flash";
export default {
    name: "SignUp",

    data() {
        return {
            form: {
                firstname: null,
                lastname: null,
                password: null,
                username: null,
                email: null,
            },
            loading: false,
            conditionsAccepted: false,
            errorStore: errorStore.state,
						mailRegistration: false
        };
    },

    components: {
        InputPassword,
        UnavailableMenu,
        Flash,
    },
    methods: {
        open() {
            this.$refs.modal.open();
            this.$emit("update:activeModal", "signup");
        },

        openSignIn() {
            this.close();
            this.openModal("signin");
            /* setTimeout(() =>{
        this.$refs.modal.open()
        this.$emit('update:activeModal', 'signin')
      },1000) */
        },

        openModal(target) {
            this.$emit("openModal", target);
        },

				openMailRegistration() {
					this.mailRegistration = !this.mailRegistration
				},

        close() {
            this.$emit("update:activeModal", null);
            this.$emit("close", null);
        },

        login(provider) {
            if (provider) {
                container.get("services.oauth").providerSignIn(provider);
            } else {
                container
                    .get("services.oauth")
                    .signIn(this.form)

                    .then((response) => {
                        this.loading = false;
                        window.location.reload();
                    }).then((response) => {
											this.$emit('recipeCoupon')  
										})

                    .catch((response) => {
                        this.loading = false;
                        errorStore.formatMessage(response);
                    });
            }
        },
        register() {
            this.loading = true;
            errorStore.removeMessage();
            container
                .get("services.oauth")
                .signUp(this.form)
                .then((response) => {
                    return container.get("services.oauth").signIn(this.form);
                })
                .then((response) => {
                    this.$emit("loginSuccess");
                    this.$emit('fillCart')
                    this.$emit('recipeCoupon')  


                    UserProvider((i) => {
                        this.loading = false;
                        this.$root.updateUser(container.get("user"));
                        this.close();
                    })               
                }) 

                .catch((response) => {
                    this.loading = false;
                    errorStore.formatMessage(response);
                });
        },

        inputEmail($event) {
            this.form.email = $event.target.value;
            this.form.username = $event.target.value;
            sessionStorage.setItem("email", $event.target.value);
        },
        testingFillForm() {
            let cookies = container.get("services.cookies");
            if (
                cookies.get("signup-dev") + localStorage.getItem("signup-dev")
            ) {
                let date = new Date().getTime();
                this.form.firstname = "test firstname " + date;
                this.form.lastname = "test lastname " + date;
                this.form.email = date + "@test.quomi.it";
                this.form.username = date + "@test.quomi.it";
                this.form.password =
                    Math.floor(Math.random() * 1000) +
                    "-" +
                    date +
                    "-" +
                    Math.floor(Math.random() * 1000);
                this.conditionsAccepted = true;
            }
        },
        persistName(e) {
            sessionStorage.setItem("firstname", e.target.value);
        },
        persistLastName(e) {
            sessionStorage.setItem("lastname", e.target.value);
        }
    },
    mounted() {
        if (sessionStorage.firstname) {
            this.form.firstname = sessionStorage.getItem("firstname");
        }
        if (sessionStorage.lastname) {
            this.form.lastname = sessionStorage.getItem("lastname");
        }
        if (sessionStorage.email) {
            this.form.email = sessionStorage.getItem("email");
        }
        this.testingFillForm();
    }
};
</script>

<style scoped>
.btn {
    width: 100%;
}

.checkbox {
    font-size: 12px;
    cursor: pointer;
    vertical-align: sub;
    padding-left: 2px;
}

.modal-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0 10px 0;
    border-bottom: none;
}

.modal-header img {
    width: 30%;
}

.sign-in-link {
    color: var(--quomi-blue);
}

.sign-in-link:hover {
    color: var(--quomi-blue-hover);
    cursor: pointer;
}

.facebook-btn {
    width: 100%;
    display: inline-block;
    color: white;
    padding-bottom: 5px;
}

.google-btn {
    width: 100%;
    display: inline-block;
    border: 1px solid;
		border-radius: 30px;
    outline: none;
}

.google-text {
    text-transform: lowercase;
}
.google-text::first-letter {
    text-transform: uppercase;
}

.fa-google {
    background: conic-gradient(
            from -45deg,
            #ea4335 110deg,
            #4285f4 90deg 180deg,
            #34a853 180deg 270deg,
            #fbbc05 270deg
        )
        73% 55%/150% 150% no-repeat;
    background-clip: text;
    color: transparent;
}

.email-text {
	color: var(--quomi-primary);
	text-transform: lowercase;
}

.signup-cta:hover {
    padding-top: 12px !important;
    padding-top: 12px !important;
}

.email-btn {
	width: 100%;
  display: inline-block;
	border-radius: 30px;
	outline: none;
}

.email-btn:hover >>> .email-text {
	color: white;
}

.email-btn.v-btn--outlined {
    border: 1px solid var(--quomi-primary);
  }

@media (max-width: 320px) {
		.google-btn,
		.email-btn {
        border-radius: 30px; 
				width: fit-content; 
    }
		
		.facebook-btn,
		.google-text,
		.email-text {
			font-size: 12px
		}
}
</style>